import React, { useState, useEffect } from 'react';
// import CircularProgress from "@mui/material/CircularProgress";
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import LinearProgress from "@mui/material/LinearProgress";
import Button from "@mui/material/Button";

import IconButton from '@mui/material/IconButton';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import PhysicianView from './physician-view.component';
import { Physician, PhysicianCredential } from '../../../../models';
import api from '../../../../api/medAppApi'
import LoadingPageIndicator from '../../../../components/LoadingPageIndicator';
import { selectUnverified } from '../../store/selectors';
import { loadUnverifiedPhysicians } from '../../store/actions';
import { putMessage } from '../../../app/store/actions';

const PhysicianViewPage: React.FC<{
  load?: boolean;
}> = ({
  load = false
}) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [shouldLoad, setShouldLoad] = useState(load);
    const [isLoading, setIsLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    const [physician, setPhysician] = useState<Physician | undefined>();
    const [credentials, setCredentials] = useState<PhysicianCredential[]>([])
    let { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();
    const unverifiedPhysicians = useSelector(selectUnverified<number>('unverifiedPhysicians'));
    const fileFromUrl = (url: string)  => {
      const splits = url.split("/");
      return (process.env.REACT_APP_HOST || 'https://api.letstalkmd.net') + '/admin/api/download-credential/' +  splits[splits.length - 1];
    }
    const fileNameFromUrl = (url: string)  => {
      const splits = url.split("/");
      return splits[splits.length - 1];
    }
    
    const check = async (modelId: number) => {
      setIsLoading(true);
      try {
        let ans = await api.viewModel<Physician>({modelName: "physician", modelId, populate:"Credential"});
        if (ans.code === 200) {
          const credentials_ = await api.getModelList<PhysicianCredential>({
            modelName: 'credential',
            returnType: 'list',
            crieteria: {Physician: ans!.data!.data!.payload!.id}
          })
          setCredentials(credentials_.data!.data.payload);

          setPhysician(ans.data!.data.payload);
        }
        
        else {
          console.log(ans);
        }

      } catch (err) {
        dispatch(putMessage({
          type: 'error',
          message: 'Something went wrong'
        }))
        console.log(err);
      }
      setIsLoading(false)
    }

    useEffect(() => {
      if (shouldLoad && id) {
        let modelId = parseInt(id!);
        if (isNaN(modelId)) {
          return;
        }
        check(modelId)
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldLoad, id]);


    const onClick = async () => {
        console.log('suususu')
      if (!physician || loading) return;
      setLoading(true);
      try {

        let ans = await api.updateModel<Physician>({modelName: "physician", where: { id: physician.id }, update: {
          Status: 1,
          isVerified: !physician.isVerified
        }})
        console.log(ans)
        if (ans.code === 200) {
        let total = unverifiedPhysicians + (physician.isVerified ? 1 : -1);
        if(total < 0) {
            total = 0;
        }
          dispatch(loadUnverifiedPhysicians(total))
          setPhysician(ans.data!.data.model);
          dispatch(putMessage({type: 'info', message: 'Update successful'}))
        }
        else console.log(ans)
      } catch (err) {
        console.log(err)
      }

     

      setLoading(false);
 

    }
    const downloadMou = () => {
      if(!physician || !credentials.length || !credentials[0].memOfUnderstanding) {
        return;
      }
      setLoading(true)
      const url = fileFromUrl(credentials[0].memOfUnderstanding)
      fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download =  'MEMORANDOM_OF_UNDERSTANDING_' + physician!.userId + fileNameFromUrl(credentials[0].memOfUnderstanding!) ;
        link.click();
        setLoading(false)
    })
    .catch((err) => {
      console.error(err);
      setLoading(false);
    });
    }

    const renderCredential = () => {

      if (!physician) return (<>lion</>)


      else if (physician && credentials.length) {
 
        return (<div style={{
          padding: '1em',
          borderRadius: '24px',
          border: '1px solid rgba(107, 119, 154, 0.1)',
          marginTop: '1.2em'
        }}>
          <Typography component="h6" variant="h6" fontWeight={'bold'} sx={{mb: 2, mt: 1}}> 
            Professional Documents
          </Typography>

          <Box display={'flex'} alignItems={'center'} style={{
            padding: '1em',
            borderRadius: '24px',
            backgroundColor: '#F8F8FA'
          }}>
            <Typography color={'#6B779A'} flexGrow={1}>
              Government Issued ID Card
            </Typography>

            <Box style={{
              position: 'relative',
              display: 'inline-block'
            }}>
              <img style={{
                width: '100px',

              }} src={fileFromUrl(credentials[0].idCardUrl)} alt={'Government Issued ID Card'} />
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                backgroundColor: '#ffffffa3',
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <a rel='noreferrer' href={fileFromUrl(credentials[0].idCardUrl)}
                  target={'_blank'} style={{
                    color: '#000000'
                  }}>
                  <IconButton color='inherit'>
                    <SaveAltIcon />
                  </IconButton>
                </a>
              </div>
            </Box>

          </Box>

          <Box display="flex" alignItems={'center'} style={{
            padding: '1em',
            borderRadius: '24px',
            backgroundColor: '#F8F8FA', marginTop: '1.2em'

          }}>
            <Typography color={'#6B779A'} flexGrow={1}>
              Medical Certificate {credentials[0].memOfUnderstanding}
               </Typography>


            <Box style={{
              position: 'relative',
              display: 'inline-block'
            }}>
              <img style={{
                width: '100px',

              }} src={fileFromUrl(credentials[0].medCertificateUrl)} alt={'Medical Certificate'} />

              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                backgroundColor: '#ffffffa3',
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <a rel='noreferrer' href={fileFromUrl(credentials[0].medCertificateUrl)} target={'_blank'}
                  style={{
                    color: '#000000'
                  }}
                >
                  <IconButton color='inherit'>
                    <SaveAltIcon />
                  </IconButton>
                </a>
              </div>

         
            </Box>
            
          </Box>
          {!!credentials[0].memOfUnderstanding ? (
                <Box marginY={2}>
                  <Button variant="contained" onClick={() => downloadMou()}>Download MOU</Button>
                </Box>
              ) : null}
        </div>
        );
      }

    }

    return (
      <Box sx={{
        width: {
          md: '80vw',
          sm: '100%'
        },
        maxWidth: '800px',
        minWidth: '250px',
        pl: 2
      }}>
        {loading && (<LinearProgress />)}
        {physician && <PhysicianView show={false} onClick={onClick} physician={physician!} />}
        {isLoading && <LoadingPageIndicator />}
        {renderCredential()}


      </Box>
    );
  }

export default PhysicianViewPage
